const ModalSize = {
  EXTRA_SMALL:  400,
  SMALL:  640,
  MEDIUM:  768,
  LARGE:  1024,
  EXTRA_LARGE:  1280,  
};

export default ModalSize;